import { Link } from 'react-router-dom';

import { stores } from "../../../../datas/stores"
import { useParams , useLocation} from "react-router-dom";
import { MdDownloadForOffline } from "react-icons/md";
import { getPdfUrl } from "../../../../utils/pdf";
// import { MdBlindsClosed } from "react-icons/md";
// import { LuPanelsLeftBottom } from "react-icons/lu";
// import { MdGrid4X4 } from "react-icons/md";
// import { MdOutlineVerticalShadesClosed } from "react-icons/md";
// import { RiLightbulbFlashFill } from "react-icons/ri";
// import { MdColorLens } from "react-icons/md";

function Store() {
    const { storesType } = useParams();
    console.log("Test Store", storesType);
    const storeContentType = stores[storesType];
    const { pathname } = useLocation();

    if (!storeContentType) return <p>Type de stores introuvable {storesType}</p>

    return (
        <div key={pathname} className="flex flex-col gap-4 lg:gap-8 xl:gap-12 min-h-[70vh] py-[5vh] xl:py-[10vh] 2xl:py[15vh] px-[5vw] xl:px-[8vw] opacity-0 animate-zoom-in">
            <div className='flex flex-col gap-6 md:gap-10 xl-gap-14'>
                <h1 className=" text-center xl:pb-6 text-xl sm:text-2xl md:text-4xl lg:text-6xl xl:text-6xl 2xl:text-8xl font-bold">{storeContentType.titre}</h1>
                <div className=''>
                    <p className="p-6 md:p-10 xl:p-16 text-justify border-y border-brun-contrast/50">
                        {storeContentType.intro}
                    </p>
                </div>
            </div>
            <div className='flex flex-col gap-[10vh] xl:gap-[14vh] 2xl:gap-[16vh] py-10 xl:py-20'>
                {storeContentType.items.map((item, index) => 
                <div key={index} className="flex flex-col lg:flex-row gap-2 md:gap-4 xl-gap-8 bg-white rounded text-brun-dark/80">
                    <div className="w-full lg:w-1/3 py-4 md:py-6 flex flex-col items-center justify-around">
                        <h2 className="font-semibold uppercase text-center">{item.titre}</h2>
                        <div className="w-full h-[250px] md:h-[300px] xl:h-[350px] flex items-center justify-center">
                            <img src={item.image} alt={item.titre} className='max-h-full max-w-full object-contain rounded'></img>
                        </div>
                    </div>
                    <div className="w-full lg:w-2/3 py-4 md:py-6 flex flex-col gap-4 md:gap-6 xl:gap-10 px-4 text-justify bg-brun-contrast/10">
                        <div className="flex flex-1 flex-col justify-between gap-4 md:gap-6 xl:gap-10 pb-6 border-b-2 border-brun-contrast/50 max-h-[300px] md:max-h-[350px] xl:max-h-[400px] overflow-auto pr-2">
                            <h4 className="font-semibold text-center text-brun-contrast">{item.intro}</h4>
                            <div className="px-6">{item.presentation}</div>
                            {/* Coorriger list */}
                            {item.disponibilites && (
                                <ul className=" px-8 italic list-disc list-inside">
                                    {item.disponibilites.map((carac, index) => (
                                        <li className="list-none" key={index}>{carac}</li>
                                    ))}
                                </ul>                
                            )}
                            <div className="px-6">{item.conclusion}</div>
                        </div>
                        <div className="flex flex-col md:flex-row gap-4 md:gap-6 xl:gap-10 items-center md:items-start w-full">
                            <div className="w-full md:w-1/2 flex justify-center md:justify-start xl:justify-center">
                                {item.logo && (
                                    <img src={item.logo} alt="Logo de la marque" className="max-w-[200px] md:max-w-[250px]"></img>
                                )}
                            </div>
                            <div className="w-full md:w-1/2 flex flex-col items-center md:items-end gap-4 xl:justify-center">
                                <div className="w-full text-end font-semibold text-brun-contrast">{item.prix}</div>
                                {item.fiche && (
                                    // download a rajouter si custom domain et domain same [A tester]
                                    <a className="p-4 w-full flex items-center justify-center gap-4 rounded-md bg-brun-contrast text-white hover:bg-brun-main transition duration:300" href={getPdfUrl(item.fiche)} target="_blank" rel="noopener noreferrer">
                                        Télécharger la fiche Produit <MdDownloadForOffline/>
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                )}
            </div>
            {/* overflow-x-auto */}
            <div className='flex flex-col gap-6 md:gap-10 xl-gap-14 overflow-x-auto'>
                <table className="min-w-full text-left text-center">
                  <thead className="bg-brun-main">
                    <tr>
                      <th className="px-4 py-2 border-2 border-beige"></th>
                      <th className="px-4 py-2 border-2 border-beige text-brun-contrast">Store sans coffre</th>
                      <th className="px-4 py-2 border-2 border-beige text-brun-contrast">Store avec coffre</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="">
                      <td className="px-4 py-2 border-2 border-beige font-medium bg-brun-main text-brun-contrast">Protection toile</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Partielle</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Totale</td>
                    </tr>
                    <tr className="">
                      <td className="px-4 py-2 border-2 border-beige font-medium bg-brun-main text-brun-contrast">Motorisation</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Standard</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Option</td>
                    </tr>
                    <tr className="">
                      <td className="px-4 py-2 border-2 border-beige font-medium bg-brun-main text-brun-contrast">LED</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Non</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Oui</td>
                    </tr>
                    <tr className="">
                      <td className="px-4 py-2 border-2 border-beige font-medium bg-brun-main text-brun-contrast">Design</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Classique</td>
                      <td className="px-4 py-2 border-2 border-beige bg-brun-contrast">Premium</td>
                    </tr>
                  </tbody>
                </table>
            </div>
            <div className='flex flex-col gap-6 md:gap-10 xl-gap-14'>
                <h2 className=" text-center xl:py-6 text-xl md:text-2xl lg:text-4xl 2xl:text-6xlxl font-bold">Demandez votre étude personnalisée</h2>
                <div className='gap-2 lg:gap-4 2xl:gap-8'>
                    <div className="flex flex-col p-6 md:p-10 xl:p-16 gap-6 text-center items-center border-t border-brun-contrast/50">
                        <div>
                            <p>Vous avez un projet de stores pour votre terrasse ou votre jardin ?</p>
                            <p>Nos équipes vous accompagnent pour définir la solution la plus adaptée à votre espace et à votre budget.</p>
                        </div>
                        <Link to='/devis/' className="lg:w-[50%] w-full mt-6 py-2 lg:py-4 2xl:py-6 rounded-full bg-brun-main text-beige hover:bg-brun-contrast hover:text-brun-dark transition duration:300 text-center sm:text-base md:text-md lg:text-lg xl:text-xl 2xl:text-2xl">Obtenir un devis gratuit</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Store;